import React, { useContext } from "react"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import { X, ChevronDown } from "lucide-react"
import useStyles from "../../styles"
import { AuthContext } from "../../../../context/Auth/AuthContext"

// Componente para o Autocomplete de Filas
const QueueAutocomplete = ({ selectedQueue, onQueueSelect }) => {
  const classes = useStyles()
  const { user } = useContext(AuthContext)

  return (
    <Grid xs={12} item>
      <Autocomplete
        className={classes.autocomplete}
        required
        fullWidth
        noOptionsText="Nenhuma fila encontrada"
        value={user?.queues?.find((q) => q.id === selectedQueue) || null}
        onChange={(event, newValue) => {
          onQueueSelect(newValue ? newValue.id : "")
        }}
        popupIcon={<ChevronDown className={classes.iconChevronDown} strokeWidth={2.0} size={"24px"} />}
        closeIcon={<X className={classes.iconX} strokeWidth={2.0} size={"24px"} />}
        options={user.queues}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Selecione uma fila"
            fullWidth
            InputLabelProps={{
              classes: {
                root: classes.label,
              },
            }}
            InputProps={{
              ...params.InputProps,
              classes: { input: classes.textField },
            }}
          />
        )}
        renderOption={(option, state) => (
          <div key={option.id}>
            <Typography
              component="span"
              style={{
                fontSize: 14,
                marginLeft: "10px",
                display: "inline-flex",
                alignItems: "center",
                lineHeight: "2",
              }}
            >
              {option.name}
            </Typography>
          </div>
        )}
      />
    </Grid>
  )
}

export default QueueAutocomplete
